import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import BaseModal from '../../form/BaseModal';
import VerticalLabelList from '../../label/VerticalLabelList';
import Grid from '../../grid/Grid';
import FieldSet from '../../fieldset/FieldSet';

class DetailedPropertyTaxBill extends React.Component {
  static exclusions = [ 'paymentTransactions', 'clientData', ];

  formatTransactions(paymentTransactions = []) {
    return paymentTransactions.map((value) => {
      const ref = { ...value, };
      ref.paymentAmount = value.paymentAmount ?? '';
      ref.paymentDate = value.paymentDate ? new Date(value.paymentDate).toLocaleString() : '';
      return ref;
    });
  }

  render() {
    const { bill, } = this.props;
    const items = VerticalLabelList.toList(bill);
    const { paymentTransactions = [], } = bill;
    const transactionModel = Grid.toModelFromList(paymentTransactions, {
      headerFormatter: value => _.startCase(value.header),
    });

    return (
      <BaseModal title="Property Tax Bill" buttonLbl="Details">
        <FieldSet title="Property Tax Bill">
          <VerticalLabelList items={items} exclusions={DetailedPropertyTaxBill.exclusions} />
        </FieldSet>
        <FieldSet title="Payment Transactions">
          <Grid
            headers={transactionModel.headers}
            rows={transactionModel.format(this.formatTransactions(paymentTransactions))}
          />
        </FieldSet>
      </BaseModal>
    );
  }
}

DetailedPropertyTaxBill.propTypes = {
  bill: PropTypes.object.isRequired,
};

export default DetailedPropertyTaxBill;
